import React, { useState, useEffect } from "react";

import { SubMenu } from "../../components/SubMenu";
import { Poster } from "../../components/Poster";
import AddToCalendarButton from "../../components/AddToCalendarButton";
import { useStore } from "../../context/state";
import CompanyLogo from "../../images/img/logo1.png";
import Breadcrumbs from "@material-ui/core/Breadcrumbs";
import Avatar from "@material-ui/core/Avatar";
import Link from "@material-ui/core/Link";
import Button from "@material-ui/core/Button";
import ShoppingCart from "@material-ui/icons/ShoppingCart";
import FormControl from "@material-ui/core/FormControl";
import FormGroup from "@material-ui/core/FormGroup";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Checkbox from "@material-ui/core/Checkbox";
import { getMinDate } from "ecommerce-commons-ui/core/Checkout/CheckoutStepForm/Delivery/utils";
import Tooltip from "@material-ui/core/Tooltip";
import { DatePicker } from "@material-ui/pickers";
import TextField from "@material-ui/core/TextField";
import EventIcon from "@material-ui/icons/Event";
import { Menu } from "../../components/Menu";
import { ExpressCheckout } from "../../components/ExpressCheckout";
import Typography from "@material-ui/core/Typography";
import {defaultValues} from "ecommerce-commons-ui/core/Checkout/CheckoutStepForm"
import CartContent from "./CartContent";
import {
    prettyDateUSA,
    dateToTimeAMPM,
    dateToISODate,
} from "commons-ui/core/utils/date";
import Loading from "commons-ui/core/Loading";

export const Page = ({ item, filters, itemIdValue, itemIdValueParent, deliveryOption, products, loading, onBack, location }) => {
    const [deliveryRequestedDate, setDeliveryRequestedDate] = useState(null)
    console.log("ITEM", item)
    const [isGift, setIsGift] = useState(false)
    const [giftSenderName, setGiftSenderName] = useState("")
    const [giftRecipientName, setGiftRecipientName] = useState("")
    const [giftMessage, setGiftMessage] = useState("")
    const [paymentLoading, setPaymentLoading] = useState(false);
    const [values, setValues] = useState(defaultValues());

    const { dispatch, apiPath, isMobile, mediaPath, ecommerceStoreId, ecommerceStoreGroupId, recaptchaKey } = useStore();

    const statesInclude = (item.state || "").split(";").filter(v => !!v).map(v => v.toUpperCase());

    const startAt = new Date(item.start_at);
    startAt.setHours(0, 1);
    const endAt = new Date(item.end_at);
    endAt.setHours(23, 59);
    const now = new Date();

    const cutoffAt = item.cutoff_at
        ? new Date(item.cutoff_at)
        : undefined;

    const isPostponed = item.is_postponed;
    const isSoldOut = item.is_sold_out || (
        cutoffAt
            ? now.getTime() > cutoffAt.getTime()
            : false);

    let date = prettyDateUSA(startAt);
    if (startAt.getTime() !== endAt.getTime()) {
        date += " - " + prettyDateUSA(endAt);
    }


    const onRedirect = () => {
        //const ruleId = deliveryOption.ecommerce_store_delivery_option_id
        const deliveryItem = { ...item, delivery_requested_date: deliveryRequestedDate }
        dispatch("cart", { products: products.map(product => ({ product, count: parseInt(product.quantity) || 1 })), ecommerceStoreId, deliveryItem, reset: true, featureList: [] }, "add_product_without_cart");
        setTimeout(() => dispatch("/checkout"), 200)
    }
    const nowTime = new Date();
    const disableDays = (date) => {
        try {
            if (date.getTime() < (nowTime.getTime()) - 24 * 60 * 60 * 1000) {
                return true
            }
            const days = (item.requested_date_disabled_days_of_week || deliveryOption.requested_date_disabled_days_of_week || "").split(";");
            for (let i = 0; i < days.length; i++) {

                let convertedDay = parseInt(days[i]) + 1;
                if (convertedDay === 7) {
                    convertedDay = 0;
                }
                if (date.getDay() === convertedDay) {
                    return true;
                }
            }

            if (item.start_at && item.end_at) {
                const startAt = new Date(item.start_at);
                startAt.setHours(0);
                startAt.setMinutes(0);
                const endAt = new Date(item.end_at);
                endAt.setHours(23);
                endAt.setMinutes(59);
                if (date.getTime() < startAt.getTime() || date.getTime() > endAt.getTime()) {
                    return true;
                }
            }

            if ((item.requested_date_disabled_start_at || deliveryOption.requested_date_disabled_start_at) && (item.requested_date_disabled_end_at || deliveryOption.requested_date_disabled_end_at)) {
                const startAt = new Date(item.requested_date_disabled_start_at || deliveryOption.requested_date_disabled_start_at);
                startAt.setHours(0);
                startAt.setMinutes(0);
                const endAt = new Date(item.requested_date_disabled_end_at || deliveryOption.requested_date_disabled_end_at);
                endAt.setHours(23);
                endAt.setMinutes(59);
                if (date.getTime() >= startAt.getTime() && date.getTime() <= endAt.getTime()) {
                    return true;
                }
            }
        } catch (e) {
            console.log("disable date error", e);
        }

        return false;
    };

    if (loading) {
        return <Loading />;
    }

    const banner = isMobile ? item.banner_mobile || item.banner : item.banner || item.banner_mobile;

    console.log(item, deliveryOption, item.delivery_requested_date_shift_minutes || deliveryOption.delivery_requested_date_shift_minutes, item.delivery_requested_time_options || deliveryOption.delivery_requested_time_options, item.delivery_requested_time_options_interval || deliveryOption.delivery_requested_time_options_interval)

    return (<div className="event-page background-wrapper">
        <div className="container u-xs-padding0">
            <div className="paper-box u-paddingLeft80 u-paddingRight80 u-xs-paddingHorizontal24 u-paddingBottom100" style={{
                minHeight: "calc(100vh - 60px)"
            }}>
                <SubMenu />
                <div className="u-marginTop10 u-paddingBottom8 u-borderBottom1 u-borderColorLighter u-hide">
                    <Breadcrumbs className=" u-textColorDarker" aria-label="breadcrumb">
                        <Link color="inherit" className="u-cursorPointer" onClick={() => dispatch("/")}>
                            Home
                        </Link>
                        <Link color="inherit" className="u-cursorPointer" onClick={() => dispatch("/events")}>
                            Events
                        </Link>
                        <div className="u-textPrimary" style={{ fontFamily: "Piroshky", letterSpacing: "2px", fontSize: "30px" }}>{item.name}</div>
                    </Breadcrumbs>
                </div>
                <div className=" u-relative">
                    {
                        banner ?
                            <div className="u-flexCenter u-justifyContentCenter">
                                <img alt="Events Banner" className="u-borderRadius10 u-maxWidth600" style={{ maxHeight: 260, maxWidth: "100%" }} src={mediaPath + banner} />
                            </div>
                            :
                            null
                    }

                    <div className="u-absolute u-hide" style={{
                        bottom: -100,
                        left: isMobile
                            ? 20
                            : 30
                    }}>
                        <Avatar className={"u-marginBottom20 " + (
                            isMobile
                                ? "u-width150 u-height150"
                                : "u-width200 u-height200")} src={CompanyLogo} />
                    </div>
                </div>



                <div className="u-flexCenter u-justifyContentCenter">
                    <div className="u-marginTop20 u-sizeFullWidth u-flex u-justifyContentSpaceBetween u-flexColumn u-border1 u-borderColorLighter u-padding15 u-borderRadius10 u-maxWidth600">
                        <div className={"u-marginBottom8 " + (
                            isMobile
                                ? " u-flexCenter u-justifyContentCenter"
                                : " u-flexCenter u-justifyContentCenter ")}>
                            <h2 className="u-fontWeightBold u-textColorPrimary" style={{ fontFamily: "Piroshky", letterSpacing: "2px", fontSize: "30px" }}>
                                {item.name}
                            </h2>
                        </div>

                        <div className="u-sizeFullWidth">
                            <div className="u-hide">
                                <div className="u-textColorDarker u-marginBottom2">
                                    Price: -
                                </div>
                                <div className="u-textColorNormal">
                                </div>
                            </div>
                            {
                                item.description
                                    ? (<div className="u-marginTop5">
                                        <div className="u-textColorNormal">{item.description}</div>
                                    </div>)
                                    : null
                            }
                        </div>
                        <div className={"u-sizeFullWidth u-flexColumn u-justifyContentStart u-xs-marginTop5 " + (
                            isMobile
                                ? ""
                                : "")}>

                            {
                                item.min_order
                                    ? (<div className="u-marginTop5 u-textColorDarker">
                                        <Tooltip title={"Min. order of in-house items before tax"
                                        }>
                                            <div className="u-flexColumn ">
                                                <span className="u-textColorDarker u-marginBottom2">Min. order:{" "}</span>
                                                <span className="u-textColorNormal">
                                                    ${item.min_order}
                                                </span>
                                            </div>
                                        </Tooltip>
                                    </div>)
                                    : null
                            }

                            <div className="u-marginTop10">
                                {
                                    isSoldOut || isPostponed
                                        ? (<div className="u-textColorRed u-fontWeightBold">
                                            {
                                                isSoldOut
                                                    ? "Sold Out"
                                                    : "Postponed"
                                            }
                                        </div>)
                                        : (<Button className="button-secondary u-hide" variant="outlined" onClick={() => {
                                            saveToLS("preorderEventId", v);
                                            dispatch("/menu");
                                        }}>
                                            Pre-Order
                                        </Button>)
                                }
                            </div>
                            <div className="u-marginBottom20">
                                <CartContent items={products} mediaPath={mediaPath} isMobile={isMobile} apiPath={apiPath} ecommerceStoreId={ecommerceStoreId} location={location} />
                            </div>

                            <div className="">
                                <div className="u-flexCenter u-justifyContentCenter">
                                    <FormControl
                                        className="u-maxWidth300"
                                        component="fieldset">
                                        <FormGroup>
                                            <FormControlLabel
                                                control={
                                                    <Checkbox
                                                        color="secondary"
                                                        onChange={(e) => setIsGift(event.target.checked)}
                                                        checked={isGift}
                                                        className="" />
                                                }
                                                label={"This is a Gift"}
                                            />
                                        </FormGroup>
                                    </FormControl>
                                </div>

                                {
                                    isGift ?
                                        <div className="u-marginBottom10 u-flexCenter u-justifyContentCenter">
                                            <div className="u-sizeFullWidth u-maxWidth300">
                                                <TextField
                                                    label="Gift To *"
                                                    margin="dense"
                                                    className="u-sizeFullWidth u-marginVertical8"
                                                    onChange={(e) => setGiftRecipientName(e.target.value)}
                                                    variant="outlined"
                                                    value={giftRecipientName}
                                                />
                                                <TextField
                                                    label="Gift From *"
                                                    margin="dense"
                                                    className="u-sizeFullWidth u-marginBottom8"
                                                    onChange={(e) => setGiftSenderName(e.target.value)}
                                                    variant="outlined"
                                                    value={giftSenderName}
                                                />

                                                <TextField
                                                    label="Gift Message *"
                                                    margin="dense"
                                                    multiline
                                                    rows={2}
                                                    className="u-sizeFullWidth u-marginVertical8"
                                                    onChange={(e) => setGiftMessage(e.target.value)}
                                                    variant="outlined"
                                                    value={giftMessage}
                                                />
                                            </div>
                                        </div>
                                        :
                                        null
                                }
                            </div>

                            <div className="u-flexCenter u-marginBottom15 u-justifyContentCenter">
                                <DatePicker
                                    disableToolbar
                                    disablePast
                                    variant="inline"
                                    className="u-sizeFullWidth u-maxWidth300"
                                    inputVariant="outlined"
                                    format="MM/dd/yyyy"
                                    margin="dense"
                                    shouldDisableDate={disableDays}
                                    disabled={!item || !deliveryOption}
                                    minDate={getMinDate(item.delivery_requested_date_shift_minutes || deliveryOption.delivery_requested_date_shift_minutes, item.delivery_requested_time_options || deliveryOption.delivery_requested_time_options, item.delivery_requested_time_options_interval || deliveryOption.delivery_requested_time_options_interval)}
                                    id="date-picker-inline"
                                    label="Ship Out Date *"
                                    helperText={"Order arrives 2 days after shipment date." + ((statesInclude && statesInclude.length) ? (" Shipping is only available to " + statesInclude.map(v => v.toUpperCase()).join(", ")) : "")}
                                    value={deliveryRequestedDate ? new Date(deliveryRequestedDate) : null}
                                    onChange={(date) => {
                                        if (disableDays(date)) {
                                            return
                                        }
                                        !date || isNaN(date.getTime()) ? null : setDeliveryRequestedDate(date.toISOString());
                                    }}
                                    KeyboardButtonProps={{
                                        "aria-label": "change date",
                                    }}
                                />
                            </div>


                            <div className="u-hide u-flexCenter u-justifyContentCenter u-marginBottom20">
                                <Button aria-label="Add Item To Shopping Cart" variant="outlined"
                                    className="button-secondary u-sizeFullWidth u-maxWidth300" color="primary" size="large"
                                >
                                    <ShoppingCart className="u-marginRight10" /> One click order
                                </Button>
                            </div>

                            <div className="u-flexCenter u-justifyContentCenter">
                                <div className="u-maxWidth300">
                                    {
                                        deliveryRequestedDate && item && deliveryOption ?
                                            <ExpressCheckout onInit={(res) => {
                                                    if (res.ok) {
                                                        window.dataLayer && window.dataLayer.push({ event: 'begin_checkout' });
                                                    } else {
                                                        //onRedirect()
                                                    }
                                                    setPaymentLoading(false)
                                                }}
                                                onValidateData={(data) => {
                                                    setValues({ ...values, ...(data || {}) });
                                                }}
                                                onSuccess={(order = {}) => {
                                                    window.dataLayer && window.dataLayer.push({
                                                        event: 'placed_order',
                                                        ecommerce: { value: order.total_amount || 10, currency: 'USD' }
                                                    });
                                                }}
                                                loading={paymentLoading}
                                                setLoading={setPaymentLoading}
                                                values={values}
                                                products={products.map(product => ({ product, count: parseInt(product.quantity) || 1, ecommerceStoreId, deliveryItem: {}, featureList: [] }))}
                                                ecommerceStoreId={ecommerceStoreId}
                                                deliveryRequestedDate={deliveryRequestedDate}
                                                rule={item}
                                                dispatch={dispatch}
                                                deliveryOption={deliveryOption}
                                                ecommerceStoreGroupId={ecommerceStoreGroupId}
                                                location={location}
                                                onRedirect={onRedirect}
                                                isMobile={isMobile}
                                                statesInclude={statesInclude}
                                                gift={{ is_gift: isGift, gift_sender_name: giftSenderName, gift_recipient_name: giftRecipientName, gift_message: giftMessage }}
                                                recaptchaKey={recaptchaKey}
                                                apiPath={apiPath} />
                                            :
                                            <div className="u-textColorRed u-marginBottom20">Select Ship Out Date</div>
                                    }
                                </div>

                            </div>

                        </div>
                    </div>
                </div>

                {/*<Menu locationId={itemIdValue} locationParentId={itemIdValueParent} filters={filters} isDisabled={isSoldOut || isPostponed} ateSelected={endAt} deliveryItem={item}/>*/}
            </div>
        </div>
    </div>);
};
